import ReadMoreDocsLink from "components/ReadMoreDocsLink";
import { getDocsUrl } from "utils/getDocsUrl";
import CollapsibleSection from "ds/components/CollapsibleSection";

import { FAQ_ITEMS } from "./content";
import LaunchPadFAQItem from "./Item";

const LaunchPadFAQ = () => {
  return (
    <CollapsibleSection
      title="FAQ"
      ariaLevel={2}
      ariaLabel="FAQ"
      contentGap="large"
      headerSuffix={<ReadMoreDocsLink docsUrl={getDocsUrl("/faq")} title="See all" />}
    >
      {FAQ_ITEMS.map(({ title, content, learnMoreContent, learnMoreTitle }) => (
        <LaunchPadFAQItem
          key={title}
          title={title}
          learnMoreContent={learnMoreContent}
          learnMoreTitle={learnMoreTitle}
        >
          {content}
        </LaunchPadFAQItem>
      ))}
    </CollapsibleSection>
  );
};

export default LaunchPadFAQ;
